import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import sOrbital from '../../images/s.svg';
import pOrbital from '../../images/p.svg';
import dOrbital from '../../images/d.svg';
import Options from '../options/Options';

interface IPaletteState {
	pushed: boolean;
	isWatchingUser: boolean;
	optionOn: boolean;
}

export class Palette extends React.Component<{}, IPaletteState> {
	orbitalType: string;
	holding: boolean;
	touchOutsideSvg: boolean;

	constructor(props: Readonly<{}>) {
		super(props);

		this.state = {
			pushed: false,
			isWatchingUser: false,
			optionOn: Options.getCurrent().showOrbitalBar,
		};

		this.orbitalType = "";
		this.holding = false;
		this.touchOutsideSvg = false;

		document.body.addEventListener("mouseup", () => this.onMouseUp());
		document.body.addEventListener("ontouchend", () => this.onMouseUp());
		document.body.addEventListener("mousemove", (e) => this.onMouseMove(e.clientX, e.clientY));
		document.body.addEventListener('watching-user', (e) => this.setState({ isWatchingUser: (e as CustomEvent).detail.isWatchingUser }), false);
	}

	public render() {
		if (this.state.isWatchingUser || !this.state.optionOn) {
			return "";
		}

		const pushedStyle = this.state.pushed ? "pushed" : "";

		return <div className={`palette-div ${pushedStyle}`}>
			<button className='palette-button button-round' onClick={() => this.pushOver()}>
				<FontAwesomeIcon icon={faAngleRight} />
			</button>
			<div className='palette'>
				<img src={sOrbital} className="s-svg" draggable="false" onMouseLeave={() => this.onMouseOut("s")} onPointerDown={() => this.onMouseDown("s")}
					onTouchEnd={() => this.onMouseUp()} onTouchStart={() => this.onMouseDown("s")}
				/>
				<img src={pOrbital} className="p-svg" draggable="false" onMouseLeave={() => this.onMouseOut("p")} onPointerDown={() => this.onMouseDown("p")}
					onTouchEnd={() => this.onMouseUp()} onTouchStart={() => this.onMouseDown("p")}
				/>
				<img src={dOrbital} className="d-svg" draggable="false" onMouseLeave={() => this.onMouseOut("d")} onPointerDown={() => this.onMouseDown("d")}
					onTouchEnd={() => this.onMouseUp()} onTouchStart={() => this.onMouseDown("d")}
				/>
			</div>
		</div>
	}

	componentDidMount() {
		const orbitals = ["s", "p", "d"];
		for (let i = 0; i < orbitals.length; i++) {
			const svg = document.getElementsByClassName(orbitals[i] + "-svg")[0] as HTMLDivElement;
			if (svg) {
				svg.addEventListener("touchmove", (e) => {
					this.onTouchMove(orbitals[i], e);
					e.preventDefault();
				});
			}
		}
	}

	onMouseUp() {
		if (this.holding && this.orbitalType) {
			const elem = document.getElementById('renderCanvas');
			if (elem) {
				elem.dispatchEvent(new CustomEvent('release-orbital', { detail: { type: this.orbitalType } }));
			}
		}

		this.orbitalType = "";
		this.holding = false;
	}

	onMouseDown(orbital: string) {
		this.orbitalType = orbital;
		this.touchOutsideSvg = false;
	}

	onMouseOut(orbital: string) {
		if (this.orbitalType === orbital && !this.holding) {
			this.holding = true;

			const elem = document.getElementById('renderCanvas');
			if (elem) {
				elem.dispatchEvent(new CustomEvent('create-orbital', { detail: { type: this.orbitalType } }));
			}
		}
	}

	onTouchMove(orbital: string, e: any) {
		e.preventDefault();

		const x = e.touches[0].clientX;
		const y = e.touches[0].clientY;
		const svg = document.getElementsByClassName(orbital + "-svg")[0].children[0].children[0] as SVGGraphicsElement;

		if (!this.touchOutsideSvg && svg) {
			const rect = svg.getBoundingClientRect();

			const isTouchOverSvg = y > rect.top && y < rect.top + rect.height &&
				x > rect.left && x < rect.left + rect.width;

			if (!isTouchOverSvg) {
				this.onMouseOut(orbital);
				this.touchOutsideSvg = true;
			}
		}

		this.onMouseMove(x, y);
	}

	onMouseMove(x: number, y: number) {
		if (!this.orbitalType) return;

		const elem = document.getElementById('renderCanvas');
		if (elem) {
			elem.dispatchEvent(new CustomEvent('move-orbital', { detail: { type: this.orbitalType, x: x, y: y } }));
		}
	}

	pushOver() {
		this.setState({ pushed: !this.state.pushed });
	}
}